import React, { Fragment } from "react";

const BoardsSpecsTable = ({ boardsData, comparePage, fields, tableHead }) => {
  //TODO: Nothing
  return (
    <table className="table-fixed bg-primary-lighter w-full mt-4">
      {(comparePage && (
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
      )) || (
        <colgroup>
          <col className={`w-1/${boardsData.length + 1}`} />
          {(boardsData || []).map((_, i) => (
            <col key={i} className={`w-1/${boardsData.length + 1}`} />
          ))}
        </colgroup>
      )}
      {tableHead && tableHead(boardsData)}
      <tbody>
        {(Object.keys(fields) || []).map((fieldKey, fieldIndex) => {
          const specs = fields[fieldKey];

          return (specs || []).map(({ label, value }, fieldSpecsIndex) => {
            return (
              <Fragment key={`${fieldIndex}${fieldSpecsIndex}`}>
                {fieldSpecsIndex === 0 && (
                  <tr className="bg-primary text-center text-lg text-white uppercase font-bold">
                    <td
                      colSpan={comparePage ? 5 : boardsData.length + 1}
                      className="px-2 py-1"
                    >
                      {fieldKey}
                    </td>
                  </tr>
                )}
                <tr className="border-b border-white">
                  <td className="font-bold text-xs p-2 border-r border-white break-words">
                    {label}
                  </td>
                  {(boardsData || []).map((board, i) => {
                    const specValue = board.specs[value];

                    if (fieldIndex === 0 && fieldSpecsIndex === 0) {
                      return (
                        <td
                          key={i}
                          className="p-2 text-xs text-cente border-r border-white break-words"
                        >
                          {board.title}
                        </td>
                      );
                    }
                    if (Array.isArray(specValue)) {
                      if (
                        specValue.length === 0 ||
                        (specValue.length === 1 && specValue[0].length === 0)
                      ) {
                        return (
                          <td
                            key={i}
                            className="p-2 text-xs text-cente border-r border-white break-words"
                          >
                            -
                          </td>
                        );
                      }
                      return (
                        <td
                          key={i}
                          className="p-2 text-xs border-r border-white break-words"
                        >
                          <ul>
                            {specValue.map((el, i) => (
                              <li key={i}>{el}</li>
                            ))}
                          </ul>
                        </td>
                      );
                    }
                    return (
                      <td
                        key={i}
                        className="p-2 text-xs text-cente border-r border-white break-words"
                      >
                        {specValue}
                      </td>
                    );
                  })}
                </tr>
              </Fragment>
            );
          });
        })}
      </tbody>
    </table>
  );
};

export default BoardsSpecsTable;
